export const buildRuleCompositeKey = (rule: {
  id: string | number
  name: string
  criteria: string
  criteria_category: string
  config_id: string | number
}) =>
  `${rule.config_id}#${rule.id}#${rule.name}#${rule.criteria}#${rule.criteria_category}`

export const parseRuleCompositeKey = (compositeKey: string) => {
  const parts = compositeKey.split('#')

  return {
    config_id: parts[0] ?? '',
    rule_id: parts[1] ?? '',
    ruleName: parts[2] ?? '',
    criteria: parts[3] ?? '',
    criteria_category: parts[4] ?? '',
  }
}
